import moment from 'moment-timezone';

// [DD] [HH:[MM:]]ss {days: ...}
export const parseDuration = (durationStringIn = '0 00:00:00') => {
  const value = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  let durationString = durationStringIn;

  // Set default duration if string is null ------
  if (!durationString) {
    durationString = '0 00:00:00';
  }

  // Fetch the Day part in DD HH:MM:ss ------
  const containsDay = (durationString.indexOf(' ') > 0);
  if (containsDay) {
    const duration = durationString.split(' ');
    value.days = parseInt(duration[0], 10);
    [, durationString] = duration;
  }
  else {
    value.days = 0;
  }

  // Fetch the Time part in  DD HH:MM:ss ------
  const durationTime = durationString.split(':');
  if (durationTime.length === 3) {
    // HH:MM:ss
    value.hours = parseInt(durationTime[0], 10);
    value.minutes = parseInt(durationTime[1], 10);
    value.seconds = parseInt(durationTime[2], 10);
  }
  else {
    // MM:ss
    value.hours = 0;
    value.minutes = parseInt(durationTime[0], 10);
    value.seconds = parseInt(durationTime[1], 10);
  }

  return value;
};

export const unParseDuration = (duration) => {
  let {
    days, hours, minutes, seconds
  } = duration;

  // Normalize seconds to minutes
  if (seconds >= 60) {
    minutes += Math.floor(seconds / 60);
    seconds %= 60;
  }

  // Normalize minutes to hours
  if (minutes >= 60) {
    hours += Math.floor(minutes / 60);
    minutes %= 60;
  }

  // Normalize hours to days
  if (hours >= 24) {
    days += Math.floor(hours / 24);
    hours %= 24;
  }

  return `${days} ${hours}:${minutes}:${seconds}`;
};

export const momentDurationString = duration => (`${Math.trunc(duration.asDays())}d ${duration.hours()}h ${duration.minutes()}m`);
export const momentDurationFormattedString = duration => (`${Math.trunc(duration.asDays())} ${duration.hours()}:${duration.minutes()}:00`);

export const getDurationString = (startTime, endTime) => {
  // Get duration moments from minutes
  if (startTime && endTime) {
    const duration = moment.duration({ minutes: endTime.diff(startTime, 'minutes') });
    return momentDurationFormattedString(duration);
  }
  return '0 0:0:00';
};

export const addDuration = (dateTime, duration) => {
  if (dateTime && duration) {
    return moment(dateTime)
      .add(duration.days, 'days')
      .add(duration.hours, 'hours')
      .add(duration.minutes, 'minutes');
  }
  return undefined;
};

// For rendering a raw duration string from django, to santisized string for html
export const durationString = (duration) => {
  if (duration === null) {
    return 'None';
  }
  const parsedDuration = parseDuration(duration);
  return `${parsedDuration.days}d ${parsedDuration.hours}h ${parsedDuration.minutes}m`;
};

// Django supports [DD] [HH:[MM:]]ss {days: ...}
export const djangoDurationToMoment = (duration) => {
  const parsedDuration = parseDuration(duration);
  return moment.duration({
    days: parsedDuration.days,
    hours: parsedDuration.hours,
    minutes: parsedDuration.minutes,
    seconds: parsedDuration.seconds
  });
};

// @@ Deprecated. Use the localToUtc or utcToLocal datetime functions instead
export const localToUtcDate = dateTime => (moment(dateTime)
  .toISOString());

// Converts local DateTime to UTC format as 2018-09-03T03:00:00+00:00
export const convertLocalToUtcDate = (localDateTime, inputFormat) => {
  if (localDateTime) {
    const dateTimeValue = moment.isMoment(localDateTime) ? localDateTime.format('YYYY-MM-DD HH:mm:ss') : localDateTime;
    return (inputFormat ? moment(dateTimeValue, inputFormat)
      .utc() : moment(dateTimeValue)
      .utc());
  }

  return null;
};

// Converts UTC date to local DateTime format as 2018-09-03T011:00:00+08:00
export const convertUtcToLocalDate = (utcDateTime, inputFormat) => {
  if (utcDateTime) {
    const dateTimeValue = moment.isMoment(utcDateTime) ? utcDateTime.format('YYYY-MM-DD HH:mm:ss') : utcDateTime;
    return (inputFormat ? moment(moment.utc(dateTimeValue, inputFormat)
      .toDate()) : moment(moment.utc(dateTimeValue)
      .toDate()));
  }

  return null;
};

// Sets the date entered to UTC datetime, regardless of locale.
export const convertToUtcDate = (dateTime, inputFormat) => {
  if (dateTime) {
    const dateTimeValue = moment.isMoment(dateTime) ? dateTime.format('YYYY-MM-DD HH:mm:ss') : dateTime;
    return (inputFormat ? moment.utc(dateTimeValue, inputFormat) : moment.utc(dateTimeValue));
  }

  return null;
};

// Formats the date to the desired output. Default is YYYY-MM-DDTHH:mm:ssZ
export const formatDateTime = (datetime, format = 'YYYY-MM-DDTHH:mm:ssZ') => (datetime ? datetime.format(format) : null);
